import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { SelectRefreshRate } from "../../components/SelectRefreshRate";
import { SelectVillage } from "../../components/SelectVillage";
import { Dashboard } from "../../enums/Dashboard";
import { useVspPortalCookies } from "../../hooks/useVspPortalCookies";
import { IotGatewayEventsLatest } from "./IotGatewayEventsLatest";
import { IotGatewayEventsSummary } from "./IotGatewayEventsSummary";
import { Asset } from "../../data/Asset";
import { CheckHealth } from "../Maintenance/components/CheckHealth";


export const IotGatewayDashboard: React.FC = ( ) => {

    const [ refreshCount, setRefreshCount ] = useState<number>( 0 );
    const [ refreshRate, setRefreshRate ] = useState<number>( 300_000 );
    const [ selectedEvents, setSelectedEvents ] = useState< string[ ] >( [ ] );
    const [ selectedVillage, setSelectedVillage ] = useState< string >( '' );

    const { getVillageCookies, removeDashboardCookies, setDashboardCookies } = useVspPortalCookies( );
    

    useEffect(() => {

        if ( !selectedVillage ) {
            
            return;

        }

        if( selectedEvents.length === 0 ) {
            
            return;

        }
    
        const interval = setInterval( ( ) => {
          
            setRefreshCount( refreshCount => refreshCount + 1 );

        }, refreshRate );

        return () => clearInterval( interval );

    }, [ refreshRate, selectedVillage, selectedEvents ]);
    

    const eventsSelectedHandler = ( events: string[ ] ): void => { 
        
        setSelectedEvents( events );
        setDashboardCookies( Dashboard.IotGateway, events, selectedVillage );

    };

    
    const handleSelectVillage = ( villageCode : string ) => {

        const cookiesVillage = getVillageCookies( Dashboard.IotGateway );
        if( cookiesVillage !== villageCode ) { // do not clear cookies during the initial page load

            removeDashboardCookies( Dashboard.IotGateway );

        }

        setSelectedEvents( [] );
        setSelectedVillage( villageCode );

    };
    

    return(
        
        <>
            <CheckHealth />
            
            <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 } sx={{ marginTop: '50px' }}>

                <SelectVillage asset={ Asset.Waio } dashboard={ Dashboard.IotGateway } onSelectVillage={ handleSelectVillage } />
                &nbsp;
                <SelectRefreshRate selectRefreshRate={setRefreshRate} />

            </Stack>

            <br />

            {
                selectedVillage
                    &&
                <>
                    <IotGatewayEventsSummary villageCode={ selectedVillage } onEventsSelected={ eventsSelectedHandler } refreshCount={ refreshCount } />
                    <br />
                    <IotGatewayEventsLatest events={ selectedEvents } villageCode={ selectedVillage } refreshCount={ refreshCount } />
                </>
            }
        
        </>

    );
    
}
